import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import Home from "../views/User/Home.vue";
import Profile from "../views/User/Profile.vue";
import mapsUser from "../views/User/Map.vue";
import EmployeePerformance from "../views/User/EmployeePerformance.vue";
import Survey from "../views/User/Survey.vue";
import About from "../views/User/About.vue";
import Login from "../views/Login.vue";
import Page404 from "../views/404.vue";

import AppLayout from "../layouts/AppLayout.vue";
import AdminLayout from "../layouts/AdminLayout.vue";

import AdminHome from "../views/Admin/AdminHome.vue";
import ListHadiah from "../views/Admin/HadiahList.vue";
import HasilSurvey from "../views/Admin/HasilSurvey.vue";
import MapsInfo from "../views/Admin/MapsInfo.vue";
import SlotMachine from "../views/Admin/SlotMachine.vue";
import SlotDoorprize from "../views/Admin/SlotDoorprize.vue";
import SpinWheel from "../views/Admin/SpinWheel.vue";
import Mapuser from "../components/Map";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "login",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
        meta: { guest: true },
      },
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
    ],
  },
  {
    path: "/user",
    redirect: "/user/home",
    name: "User",
    component: AppLayout,
    children: [
      {
        path: "/user/home",
        name: "home",
        component: Profile,
        meta: {
          requiresAuth: true,
          isUser: true,
        },
      },
      {
        path: "/user/about",
        name: "about",
        component: About,
      },
      {
        path: "/user/pesan",
        name: "pesan",
        component: Home,
      },
      {
        path: "/user/survey",
        name: "survey",
        component: Survey,
      },
      {
        path: "/user/performance",
        name: "performance",
        component: EmployeePerformance,
      },
      {
        path: "/user/map",
        name: "map",
        component: Mapuser,
      },
    ],
  },
  {
    path: "/admin",
    redirect: "/admin/home",
    name: "admin",
    component: AdminLayout,
    children: [
      {
        path: "/admin/home",
        name: "AdminHome",
        component: AdminHome,
        meta: {
          // change requiresAuth to true when integrating with backend, false when debugging with local
          requiresAuth: false,
          isAdmin: true,
        },
      },
      {
        path: "/admin/hadiah",
        name: "Hadiah",
        component: ListHadiah,
        props: true,
      },
      {
        path: "/admin/survey",
        name: "Survey",
        component: HasilSurvey,
      },
      {
        path: "/admin/spin/:id",
        name: "Spin",
        component: SpinWheel,
        props: true,
      },
      {
        path: "/admin/doorprize/:id",
        name: "SlotDoorprize",
        component: SlotDoorprize,
        props: true,
      },
      {
        path: "/admin/slot",
        name: "Slot",
        component: SlotMachine,
      },
      {
        path: "/admin/maps",
        name: "Maps",
        component: MapsInfo,
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({
      path: "/404",
    });
  }
  if (
    to.matched.some((record) => record.meta.guest) &&
    store.getters.loggedIn !== null
  ) {
    next("/" + store.getters.loggedIn);
    // console.log('jangkrik');
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log('harus login',store.getters.loggedIn);
    // console.log('mau ke',to);
    if (store.getters.loggedIn == null) {
      next({
        path: "/",
      });
    } else {
      if (to.matched.some((record) => record.meta.isAdmin)) {
        if (store.getters.loggedIn == "admin") {
          next();
        } else if (store.getters.loggedIn == "user") {
          next({
            path: "/user",
          });
        } else {
          next({ path: "/" });
        }
      } else if (to.matched.some((record) => record.meta.isUser)) {
        if (store.getters.loggedIn == "user") {
          next();
        } else if (store.getters.loggedIn == "admin") {
          next({
            path: "/admin",
          });
        } else {
          next({ path: "/" });
        }
      } else {
        // console.log('gass');
        // if (to.matched.some(record => record.meta.guest)) {
        //       next('/'+store.getters.loggedIn)
        //   }
        // else
        next();
      }
    }
  } else {
    // console.log('aman');
    next();
  }
});

export default router;
